import { HISTORICAL_FUNNEL_NOT_RETAINED, parseEvidenceFunnelCounts, type EvidenceFunnelCounts } from './safetyScanProductPresentation';

export type SignedEvidenceFunnelPresentation = {
  retained: boolean;
  notRetainedMessage: string | null;
  funnel: EvidenceFunnelCounts;
};

export function presentSignedEvidenceFunnel(source?: Record<string, unknown> | null): SignedEvidenceFunnelPresentation {
  const funnel = parseEvidenceFunnelCounts(source);
  const auditRetained = [
    funnel.falsePositive,
    funnel.duplicate,
    funnel.needsMoreReview,
    funnel.pending,
    funnel.reviewed,
  ].some((value) => value != null);
  if (!auditRetained) {
    return {
      retained: false,
      notRetainedMessage: HISTORICAL_FUNNEL_NOT_RETAINED,
      funnel: {
        candidate: funnel.candidate,
        reviewed: null,
        confirmed: funnel.confirmed,
        falsePositive: null,
        duplicate: null,
        needsMoreReview: null,
        pending: null,
      },
    };
  }
  return { retained: true, notRetainedMessage: null, funnel };
}
